import { createProfileAPIConfig, getUserStatusAPIConfig } from '../../../shared/api-configs/profile';
import { LOAD_STATE } from '../../../shared/axios';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { getErrorKey } from '../../../shared/utils/errors';
import { ERROR_MESSAGES } from './create-profile.constants';

export const CREATE_PROFILE_REQUEST_CALLED = '@auth/CREATE_PROFILE_REQUEST_CALLED';
export const CREATE_PROFILE_REQUEST_SUCCEEDED = '@auth/CREATE_PROFILE_REQUEST_SUCCEEDED';
export const CREATE_PROFILE_REQUEST_FAILED = '@auth/CREATE_PROFILE_REQUEST_FAILED';
export const USER_STATUS_REQUEST_CALLED = '@auth/USER_STATUS_REQUEST_CALLED';
export const USER_STATUS_REQUEST_SUCCEEDED = '@auth/USER_STATUS_REQUEST_SUCCEEDED';
export const USER_STATUS_REQUEST_FAILED = '@auth/USER_STATUS_REQUEST_FAILED';

export type State = {
    error: string,
    loadState: string,
}

export const getCreateProfileError = state => state.auth.createProfile.error;
export const isCreateProfileLoading = state => state.auth.createProfile.loadState;

export const requestCreateProfile = () => ({
    type: CREATE_PROFILE_REQUEST_CALLED,
    actionTypes: {
        success: CREATE_PROFILE_REQUEST_SUCCEEDED,
        fail: CREATE_PROFILE_REQUEST_FAILED,
    },
    config: createProfileAPIConfig(),
});

export const requestUserStatus = () => ({
    type: USER_STATUS_REQUEST_CALLED,
    actionTypes: {
        success: USER_STATUS_REQUEST_SUCCEEDED,
        fail: USER_STATUS_REQUEST_FAILED,
    },
    config: getUserStatusAPIConfig(),
});

export const initialState = {
    error: '',
    loadState: LOAD_STATE.LOADING,
};

export const createProfileReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [CREATE_PROFILE_REQUEST_CALLED]: state => ({ ...state, loadState: LOAD_STATE.LOADING }),
    [CREATE_PROFILE_REQUEST_SUCCEEDED]: state => ({ ...state, loadState: LOAD_STATE.SUCCESS }),
    [CREATE_PROFILE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: ERROR_MESSAGES[getErrorKey(action.payload.response, ERROR_MESSAGES.UNKNOWN_ERROR)],
    }),
});
